module.exports = __webpack_public_path__ + "img/2-consumers-microlines.png";